<template>
  <div>
    <div>财务导出</div>
    <div style="display: inline-block">
      <Date-picker
        type="month"
        placeholder="选择月"
        style="width: 200px"
        v-model="month"
      ></Date-picker>
    </div>
    <i-button @click="downloadReport">下载</i-button>
  </div>
</template>

<script>
import download from 'downloadjs';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      month: dayjs().subtract(1, 'month').toDate(),
    };
  },
  methods: {
    async downloadReport() {
      let month = dayjs(this.month).format('YYYY-MM');
      let {
        data: { msg, data },
      } = await this.$http.post(`v2/finance/report/${month}`, {
        station: this.station,
      });
      if (msg === 'ok') {
        download(
          `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`,
          `${month}.xlsx`
        );
      } else {
        this.$Message.error(msg);
      }
    },
  },
};
</script>
